export default "__VITE_ASSET__B7XG78OR__"